/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "DATA_ANALYTICS/LOADER_STATUS";
export const PROFILE_INFO = "DATA_ANALYTICS/PROFILE_INFO";
export const SET_VARIANCE_DATA = "DATA_ANALYTICS/SET_VARIANCE_DATA";

export const SET_CLEAR_GRAPH = "ITC_ANALYSIS/SET_CLEAR_GRAPH";

export const SET_HSN_LIST = "ITC_ANALYSIS/SET_HSN_LIST";
export const SET_GST_LIST = "ITC_ANALYSIS/SET_GST_LIST";
export const SET_RET_PERIOD = "ITC_ANALYSIS/SET_RET_PERIOD";
export const SET_VAULE_BY_TOP_HSN = "ITC_ANALYSIS/SET_VAULE_BY_TOP_HSN";
export const SET_HSN_VAULE_QTR = "ITC_ANALYSIS/SET_HSN_VAULE_QTR";

export const SET_ITC_RECO_ANALYSIS = "ITC_ANALYSIS/SET_ITC_RECO_ANALYSIS";
export const SET_ITC_RECO_ANALYSIS_AGG =
  "ITC_ANALYSIS/SET_ITC_RECO_ANALYSIS_AGG";
export const SET_ITC_RECO_VENDOR_AGG = "ITC_ANALYSIS/SET_ITC_RECO_VENDOR_AGG";
export const SET_ITC_REVERSAL = "ITC_ANALYSIS/SET_ITC_REVERSAL";
